import { ModuleWithProviders, NgModule } from '@angular/core';
import { SOFTLINE_SETTINGS_DEVELOPER } from './developer.shared';
import { DeveloperSettingsComponent } from './settings/developer-settings.component';
import { DeveloperService } from './service/developer.service';
import { SOFTLINE_CONFIG_SETTINGS } from '../application.shared';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [],
})
export class DeveloperModule {
  static forRoot(): ModuleWithProviders<DeveloperRootModule> {
    return {
      ngModule: DeveloperRootModule,
      providers: [ {
        provide: SOFTLINE_CONFIG_SETTINGS,
        multi: true,
        useValue: {
          key: SOFTLINE_SETTINGS_DEVELOPER,
          component: DeveloperSettingsComponent,
          title: '#APPLICATION.DEVELOPER.SETTINGS.TITLE',
          icon: 'fa-regular fa-screwdriver-wrench',
          priority: -1
        },
      }],
    };
  }
}

@NgModule({
  imports: [
    DeveloperModule,
  ],
  providers: [
    DeveloperService,
  ]
})
export class DeveloperRootModule { }
